import {useRouteLoaderData} from '@remix-run/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import React from 'react'
import type {RootLoaderResponse} from '~/types'
import {getTranslation} from '~/localization/translation'
import {EnvelopeIcon} from '~/icons/envelope-icon'
import {getDomainConfig} from '~/domains'
import {PhoneIcon} from '~/icons/phone-icon'
import {cssDomains} from '~/utils/constants'

interface CustomerServiceProps extends HTMLAttributes<HTMLDivElement> {}

const CustomerService: FunctionComponent<CustomerServiceProps> = ({...props}) => {
  const {domainName, language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {camelCaseUrl} = getDomainConfig(domain, locale)
  const showCustomerServiceInfo = cssDomains.includes(domainName)

  const contactEmail = `contact@${camelCaseUrl.toLowerCase()}`
  const mailToHref = `mailto:${contactEmail}`
  const contactPhone = '+44 7401 233670'

  return showCustomerServiceInfo ? (
    <div {...props}>
      <span className="font-semibold">{translations.Footer.customerService}</span>
      <div className="flex items-center gap-2">
        <EnvelopeIcon className="size-4 shrink-0" />
        <a href={mailToHref} aria-label="contact email" className="font-light">
          {contactEmail}
        </a>
      </div>
      <div className="flex items-center gap-2">
        <PhoneIcon className="size-4 shrink-0" />
        <span className="font-light">{contactPhone}</span>
      </div>
    </div>
  ) : null
}

export default CustomerService
